export const inputTokens = {
  inputtext: {
    root: {
      background: '{formField.background}',
      borderColor: '{formField.borderColor}',
      hoverBorderColor: '{formField.hoverBorderColor}',
      focusBorderColor: '{formField.focusBorderColor}',
      invalidBorderColor: '{formField.invalidBorderColor}',
      invalidBackground: '{danger.background}',
      color: '{formField.color}',
      placeholderColor: '{formField.placeholderColor}',
      borderRadius: '{borderRadius.sm}',
      shadow: 'none',
      paddingX: '0.75rem',
      paddingY: '0.25rem',
      transitionDuration: '{transition.duration}',
      focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
      }
    }
  }
};

export type InputTokens = typeof inputTokens;
